import { Box, Card, CardContent, Typography } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { groupAverage, memberRate } from "../../../lib/progressCompare";

export default function StatsSummaryCards({ userStats }) {
  const { t } = useScriptMode();
  const list = Array.isArray(userStats) ? userStats : [];
  const activeMembers = list.filter((u) => (u.daysActiveCount || 0) > 0).length;
  const totalActiveDays = list.reduce((s, u) => s + (u.daysActiveCount || 0), 0);
  // Ortalama tam sayı; üye oranı periodRate (yoksa completionRate), 100'de kesilir.
  const avgCompletion = groupAverage(list.map(memberRate));

  const items = [
    { label: t("manage_stats_summary_active_members"), value: activeMembers },
    { label: t("manage_stats_summary_active_days"), value: totalActiveDays },
    { label: t("manage_stats_summary_avg_completion"), value: `%${avgCompletion}` },
  ];

  return (
    <Box display="grid" gridTemplateColumns={{ xs: "1fr", sm: "repeat(3, 1fr)" }} gap={2}>
      {items.map((item) => (
        <Card key={item.label} variant="outlined">
          <CardContent>
            <Typography variant="caption" color="text.secondary">
              {item.label}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 700, color: "#2E7D62" }}>
              {item.value}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
